module.exports = __webpack_public_path__ + "img/goal-default.84f52fe9.svg";